module.exports = __webpack_public_path__ + "static/media/map_detail.f03f6089.png";